import React from "react"

import { MarkovGroupFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchMarkovGroup {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: MarkovGroupFilters
    onFilter: (filters: MarkovGroupFilters) => void
}

const MarkovGroupSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchMarkovGroup) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default MarkovGroupSearch
